<template>
    <div id="menu-sistema"
        class="flex relative w-full items-center justify-between bg-white dark:bg-gray-800 border-b border-solid border-b-gray-100 dark:border-b-gray-700">
        <dx-toolbar ref="toolBar" :style="estiloToolbar" :onContentReady="onContentReady"
            class="bg-white h-20 dark:bg-gray-800">
            <DxItem v-for="(item, idx ) in items" :key="idx" :text="item.nome" :widget="item.widget"
                :options="item.options" :location="item.location">
            </DxItem>
            <DxItem v-for="(item, idx ) in itensNotificacoes" :key="idx" :text="item.nome" :widget="item.widget"
                :options="item.options" :location="item.location">
            </DxItem>
            <DxItem v-for="(itemP, idxP ) in itensPerfil" :key="`p_${idxP}`" :text="itemP.nome" :widget="itemP.widget"
                :options="itemP.options" :icon="itemP.icon" location="after" :template="itemP.template"
                locateInMenu="always">
            </DxItem>
            <template #templateUser>
                <div class="flex flex-col p-[5px]  border-gray-100 dark:border-gray-800"
                    style="padding: 15px 15px 5px 15px !important;">

                    <ToggleTheme :salvar="true" />
                    <div class='flex flex-col mt-4 border-t border-solid border-t-gray-100 dark:border-t-gray-700'>
                    </div>
                </div>
            </template>
            <template #iconBellTemplate>
                <div class="flex flex-row relative items-center">
                    <div class="w-9 h-9 mr-4 flex items-center justify-center rounded bg-primary-100 ">
                      <IconBell class="text-primary-500" />
                    </div>
                    <div class="flex flex-col">
                      <p class="text-md font-bold">{{$vistra.globalize('menu-notificacoes')}}</p>
                    </div>
                </div>
                
                <div class='flex flex-col mt-2 mb-4 border-t border-solid border-t-gray-100 dark:border-t-gray-700'></div>

                <div class="flex flex-col ">
                    <div 
                        v-if="linkChangeLogs.length <= 0"
                        class="flex text-gray-900 dark:text-white border-t border-solid border-t-gray-100 dark:border-t-gray-800">
                        
                        <div class="flex flex-col">
                            <p class="text-xs font-medium pr-4 pl-4 pt-2 text-gray-500 dark:text-gray-300">
                                {{$vistra.globalize('menu-sem-notificacoes')}}
                             </p>
                        </div>
                        
                    </div>
                    <div
                    v-else
                    :key="index"
                    v-for="({  versao, url, visualizado, dataCriacao  }, index) in listNotifications"
                    class="flex text-gray-900 dark:text-white pb-5 border-b border-solid border-b-gray-100 dark:border-b-gray-700"
                    :class="index > 0 ? 'mt-6': ''"
                    @click.stop="abreChangeLog(url, index)">
                        <div
                        class="flex flex-col relative items-center notification-bullet"
                        :class="visualizado ? 'is-read' : 'is-unread'">
                            <div class="w-12 h-12 mr-3 min-w-[3rem] flex items-center justify-center rounded-full notification-bullet-bubble">
                                <IconBell />
                            </div>
                        </div>
            
                      <div class="flex flex-col">
                        <p class="text-md font-bold">{{$vistra.globalize('menu-sistema-atualizado-notificacoes')}}</p>
                        <p class="text-xs font-medium pr-2 text-gray-500 dark:text-gray-300">
                            {{$vistra.globalize('menu-nova-versao-notificacoes')}} {{ versao }}. {{$vistra.globalize('menu-veja-versao-notificacoes')}}
                        </p>
                        <p class="text-xs font-medium text-gray-500 dark:text-gray-300" v-if="!!dataCriacao">
                            {{ timeAgo(dataCriacao) }}
                        </p>

                      </div>
                    </div>
                </div>
            </template>
        </dx-toolbar>
        <div class="menu-mobile">
            <button type="button" class="hamb hidden mr-2" @click="toggleMenuMobile">
                <span class="dx-icon-menu text-xl"></span>
            </button>
        </div>
        <Drawer ref="drawerMenu" title="Menu">
            <ToggleTheme :salvar="true" />

            <div class="pt-4 mt-6 border-t-2 border-gray-100 dark:border-gray-800">
                <p class="text-lg mb-4 font-medium text-gray-800 dark:text-gray-100">
                    Gerenciar
                </p>

                <div class="flex flex-col gap-5">
                    <button v-for="({ label, icon, action }, index) in itensGerenciarMenuMobile" @click="action"
                        :key="index"
                        class="flex gap-2 items-center font-medium transition-all duration-300 !text-primary-500">
                        <i v-if="typeof icon == 'string'" style="font-size:19px " :class="icon"></i>
                        <component v-else :is="icon" />

                        <span class="!text-gray-600 dark:!text-gray-200">
                            {{ label }}
                        </span>
                    </button>
                </div>
            </div>          
            <div class="pt-4 mt-6 border-t-2 border-gray-100 dark:border-gray-800">
                <p class="text-lg mb-4 font-medium text-gray-800 dark:text-gray-100">
                    Outros
                </p>

                <div class="flex flex-col gap-5">
                    <button v-for="({ label, icon, action }, index) in itensOutrosMenuMobile" :key="name"
                        class="flex gap-2 items-center font-medium transition-all duration-300 text-primary-500"
                        @click="action">
                        <component :is="icon" />

                        <span class="text-gray-600 dark:text-gray-200">
                            {{ label }}
                        </span>
                    </button>
                </div>
            </div>
        </Drawer>
        <PanelMenu v-if="paineisJaAberto || abrePaineis" :show="abrePaineis" :usuario="usuario"
            @onClose="fechaPaineis" />

        <FormularioMenu v-if="abreFormularios" :show="abreFormularios" :usuario="usuario" @onClose="fechaFormularios" />
        <PageReports v-if="abreRelatorios" :show="abreRelatorios" :usuario="usuario" @onClose="fechaRelatorios" />
        <div class="navbar-defesa" :class="colappsedClass"></div>
        <div v-if="podeMinimizarMenu"
            class="menu-collapser dx-theme-border-color dx-theme-border-color-as-background-color"
            :class="colappsedClass" @click="setRequisitaToggleMenu">
            <span v-if="menu_collapsed">menu</span>
            <i class="fas" :class="colappsedChevron"></i>
        </div>
        <vis-grupos v-if="modalEditGrupos" :titulo="$vistra.globalize('form-grupos-paineis')" :visivel="modalEditGrupos"
            @resetarVisibilidade="resetarVisibilidadeGrupos" :nomeController="'Painel'" :grupoTemImagem="true"
            :mostrarBotaoConfirmar="false" />
    </div>
</template>

<script>
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
import IconBell from "@/assets/icons-svg/icon-bell.svg";
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import ToggleTheme from "@/components/escolhas/ToggleTheme";
import Drawer from "@/components/drawer/DrawerLayout";

import IconUser from '@/assets/icons-svg/icon-account.svg'
import IconProfile from '@/assets/icons-svg/icon-profile.svg'
import IconLogout from '@/assets/icons-svg/icon-logout.svg'
import PanelMenu from "./panelsMenu/PanelMenu.vue";
import PageReports from "@/pages/report/PageReports.vue";
import FormularioMenu from "./formulariosMenu/FormularioMenu.vue";
import { DxLoadIndicator } from 'devextreme-vue'
const eventoCliqueBotaoDoMeio = 2

export default {
    components: {
        DxToolbar, DxItem, IconUser, ToggleTheme, Drawer, PanelMenu, PageReports, FormularioMenu, DxLoadIndicator, IconBell},
    props: {
        isMenuVisible: {
            type: Boolean,
            required: true
        },
        isFullPage: {
            type: Boolean,
            default: false
        },
        podeMinimizarMenu: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            menus: [],
            loadingMenus: true,
            editandoPerfil: false,
            imagemMenu: {},
            usarIcone: true,
            usarIconePrimario: false,
            repaint: false,
            menu_collapsed: false,
            windowWidth: 1000,
            modalEditGrupos: false,
            logoPersonalizadas: true,
            itensGerenciarMenuMobile: [],
            itensOutrosMenuMobile: [
                {
                    action: () => this.direcionaMinhaConta(),
                    label: this.$vistra.globalize("menu-perfil"),
                    icon: IconProfile,
                },
                {
                    action: () => this.logout(),
                    label: this.$vistra.globalize("menu-desconectar"),
                    icon: IconLogout
                },
            ],
            abrePaineis: false,
            abreRelatorios: false,
            abreFormularios: false,
            paineisJaAberto: false,
            numberOfNotifications: 0
        };
    },
    watch: {
        "usuario.imagem"(newVal) {
            this.repintaMenu()
        },
        "usuario.idioma"(newVal) {
            this.carregaMenus()
        },
        logos: {
            deep: true,
            handler: function (newVal) {
                // console.log(newVal + 'LOGO MENU')
                this.repintaMenu()
            }
        },
        empresas(newVal) {
            this.repintaMenu()
        },
        onRequisitaToggleMenu(val) {
            this.collapseMenu();
        },
        tema(newVal) {
            // console.log(newVal + "TEMA")
            setTimeout(() => {
                if (newVal == "tema-dark") {
                    this.carregaLogo(2)
                    return
                }
                this.carregaLogo(3)
            }, 20)
        },
        onContentResized(newValue) {
            this.compactMenu = newValue.tamanho.width < 560 ? true : false
        },
        idEmpresa(newVal) {
            this.carregaMenus()
        }
    },

    computed: {

        ...mapGetters(["logos", "empresas", "idEmpresa", "usuario", "tema", "onContentResized", "linkChangeLogs"]),
        ...mapGetters(["onRequisitaToggleMenu"]),
        logoMenu() {
            this.tema
            return this.$vistra.estaNoModoEscuro() ? 'menuEscuro' : 'menuClaro'
        },
        showMenuGerenciar() {
            return this.menus.length > 0 && !this.loadingMenus;
        },
        isUsuarioSupervisor() {
            return [2, 3].includes(this.usuario.tipoUsuario)
        },
        estiloToolbar() {
            return {
                visibility: this.menu_collapsed ? 'hidden' : 'visible',
            }
        },
        isCompact() {
            return this.windowWidth <= 1024;
        },
        itensNotificacoes() {
            let items = [];
            let itensMenuNotificacao = []
            if (this.isCompact || this.usuario.perfil !== 11 && !this.isUsuarioSupervisor)
                return items;
            
            items.push({
                    location: "after",
                    locateInMenu: "never",
                    widget: "dxMenu",
                    options: {
                        adaptivityEnabled: false,
                        dataSource: [{
                            icon:  'fa fa-regular fa-bell',
                            path: "#",
                            items: itensMenuNotificacao,
                            elementId: "notificacoesMenu"
                        }],
                        showFirstSubmenuMode: "onClick",
                        cssClass: "menu-botao-notificacao",
                        hideSubmenuOnMouseLeave: true,
                    }
                })
            itensMenuNotificacao.push({
                template: 'iconBellTemplate',
                location:"after",
                locateInMenu:"always",
                path: "#",
                widget: "dxButton",

            });
            return items;
        },

        itensPerfil() {
            if (this.isCompact)
                return []


            let itensPerfil = [];

            itensPerfil.push({
                // cssClass: "w-2/4 justify-center text-center px-4 h-full relative z-10 flex text-xs font-semibold items-center rounded-full transition-all duration-300 ease-in-out",
                // nome: this.$vistra.globalize("menu-empresa"),
                template: 'templateUser',
                options: {
                    // text: this.$vistra.globalize("menu-empresa"),
                    onContentReady: (e) => {

                    }

                },
                path: "#",
                widget: "dxButton",

            });
            if (this.empresas.length > 1)
                itensPerfil.push({
                    cssClass: "menu-sistema-perfil",
                    // nome: this.$vistra.globalize("menu-empresa"),
                    options: {
                        icon: "fal fa-building",
                        items: this.empresas.map(e => {
                            return {
                                nome: e.nome,
                                icon:
                                    String(e.id) === String(this.idEmpresa)
                                        ? "fal fa-check"
                                        : "",
                                acao: "alterarEmpresaContexto",
                                idEmpresa: e.id,
                                elementId: "menuEmpresa" + e.id
                            };
                        }
                        ).sort((a, b) => {
                            if (a.nome > b.nome) {
                                return 1;
                            }
                            if (a.nome < b.nome) {
                                return -1;
                            }
                            // a must be equal to b
                            return 0;
                        }),
                        dropDownOptions: {
                            resizeEnabled: true
                        },
                        onSelectionChanged: (e) => {
                            // refaz o token e verifica se tem licença pra depois aplicar
                            if (e.selectedItem.idEmpresa == this.idEmpresa)
                                return
                            this.$http.post(`/Usuario/AlteraEmpresaContexto/${e.selectedItem.idEmpresa}/${this.usuario.chaveAutenticacao}`)
                                .then(response => {
                                    if (!response) {
                                        e.component.option('value', this.idEmpresa)
                                        return
                                    }
                                    this.$vistra.SignalRUsuariosConectados.close()
                                    let token = response.data.token;
                                    this.$store.dispatch('updateToken', token)
                                    this.$store.dispatch('setDadosUsuario', { ...response.data.usuario, ...response.data.dispositivo })
                                    this.$store.dispatch("empresaContexto", e.selectedItem.idEmpresa);
                                    this.$vistra.SignalRUsuariosConectados.start()
                                }).catch((err) => {
                                    e.component.option('value', this.idEmpresa)
                                    this.$vistra.showMessage(err.response?.data?.msg || err.response?.data || err.msg, 'error')
                                })
                        },
                        label: this.$vistra.globalize("menu-empresa"),
                        searchEnabled: true,
                        valueExpr: 'idEmpresa',
                        displayExpr: 'nome',
                        onContentReady: (e) => {
                            e.component.option('value', this.idEmpresa)
                        },
                    },
                    path: "#",
                    widget: "dxSelectBox",

                });
            itensPerfil.push({
                cssClass: "menu-sistema-perfil",
                options: {
                    onClick: () => this.$router.push('/perfil'),
                    icon: "fa-light fa-circle-user",
                    text: this.$vistra.globalize("menu-perfil"),
                },
                widget: 'dxButton',
                acao: "editarPerfil",
                elementId: "perfilUsuario"
            });


            // descomentar quando a documentação estiver ok
            // itensPerfil.push({
            //     cssClass: "menu-sistema-perfil",
            //     options: {
            //         icon: "fal fa-question-circle",
            //         text: this.$vistra.globalize("menu-ajuda"),
            //         onClick: () => {
            //             this.$vistra.abreAjuda({ desenvolvedor: this.usuario.perfil === 11 })
            //         }
            //     },
            //     acao: "ajuda",
            //     elementId: "menuAjuda",
            //     widget: 'dxButton',
            // });
            itensPerfil.push({
                cssClass: "menu-sistema-perfil",
                options: {
                    icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.0837 12.5833C16.8858 12.4851 16.6571 12.4694 16.4477 12.5397C16.2383 12.61 16.0654 12.7606 15.967 12.9583C15.4395 14.0235 14.6369 14.9283 13.6422 15.579C12.6475 16.2297 11.497 16.6026 10.3097 16.6591C9.12245 16.7157 7.94166 16.4537 6.88965 15.9005C5.83764 15.3473 4.95268 14.5228 4.32641 13.5126C3.70015 12.5023 3.35537 11.343 3.32778 10.1547C3.30019 8.96646 3.5908 7.7924 4.1695 6.75419C4.7482 5.71597 5.59395 4.85135 6.61915 4.24988C7.64435 3.64842 8.81171 3.33198 10.0003 3.33335C11.2429 3.32796 12.4619 3.67304 13.5172 4.32897C14.5726 4.9849 15.4217 5.92511 15.967 7.04168C16.0664 7.24059 16.2408 7.39185 16.4518 7.46217C16.6628 7.5325 16.8931 7.51614 17.092 7.41668C17.2909 7.31722 17.4422 7.14282 17.5125 6.93184C17.5828 6.72087 17.5664 6.49059 17.467 6.29168C16.6308 4.60897 15.2505 3.25823 13.5501 2.4587C11.8497 1.65918 9.92894 1.4578 8.09966 1.88724C6.27038 2.31669 4.63992 3.35176 3.47293 4.82445C2.30593 6.29714 1.6709 8.121 1.6709 10C1.6709 11.879 2.30593 13.7029 3.47293 15.1756C4.63992 16.6483 6.27038 17.6833 8.09966 18.1128C9.92894 18.5422 11.8497 18.3408 13.5501 17.5413C15.2505 16.7418 16.6308 15.3911 17.467 13.7083C17.5166 13.6095 17.5461 13.5017 17.5537 13.3914C17.5613 13.281 17.5468 13.1702 17.5111 13.0655C17.4754 12.9608 17.4193 12.8642 17.3459 12.7814C17.2725 12.6987 17.1833 12.6313 17.0837 12.5833ZM17.5003 9.16668H9.50865L11.4253 7.25835C11.503 7.18065 11.5647 7.08841 11.6067 6.98689C11.6488 6.88537 11.6704 6.77656 11.6704 6.66668C11.6704 6.5568 11.6488 6.44799 11.6067 6.34647C11.5647 6.24495 11.503 6.15271 11.4253 6.07501C11.3476 5.99731 11.2554 5.93568 11.1539 5.89363C11.0523 5.85158 10.9435 5.82994 10.8337 5.82994C10.7238 5.82994 10.615 5.85158 10.5134 5.89363C10.4119 5.93568 10.3197 5.99731 10.242 6.07501L6.90865 9.40835C6.83279 9.4876 6.77332 9.58105 6.73365 9.68335C6.6503 9.88623 6.6503 10.1138 6.73365 10.3167C6.77332 10.419 6.83279 10.5124 6.90865 10.5917L10.242 13.925C10.3195 14.0031 10.4116 14.0651 10.5132 14.1074C10.6147 14.1497 10.7236 14.1715 10.8337 14.1715C10.9437 14.1715 11.0526 14.1497 11.1541 14.1074C11.2557 14.0651 11.3479 14.0031 11.4253 13.925C11.5034 13.8475 11.5654 13.7554 11.6077 13.6538C11.65 13.5523 11.6718 13.4434 11.6718 13.3333C11.6718 13.2233 11.65 13.1144 11.6077 13.0129C11.5654 12.9113 11.5034 12.8191 11.4253 12.7417L9.50865 10.8333H17.5003C17.7213 10.8333 17.9333 10.7455 18.0896 10.5893C18.2459 10.433 18.3337 10.221 18.3337 10C18.3337 9.779 18.2459 9.56704 18.0896 9.41076C17.9333 9.25448 17.7213 9.16668 17.5003 9.16668Z" fill="currentColor"/>
                        </svg>
                        `,
                    text: this.$vistra.globalize("menu-desconectar"),
                    onClick: () => {
                        this.logout()
                    },
                    onContentReady: (e) => {
                        //Adiciona uma classe pernalizada para estilizar os itens do submenu do perfil
                        let achaParentMenu = (element, target) => {
                            let elFind = element.classList.contains(target)
                            if (elFind) {
                                element.classList.add('menu-perfil-personalizado')
                                let menuPersonalizado = document.querySelector('.menu-perfil-personalizado')
                                if (menuPersonalizado) {
                                    let conteudo = document.querySelector('.dx-popup-content');
                                    conteudo.classList.add('personaliza-menu-perfil')
                                    conteudo.style = 'border: 1px; border-radius: 5px;'
                                }
                                return;
                            }
                            if (element.parentElement)
                                achaParentMenu(element.parentElement, target)
                        }
                        this.$nextTick(() => achaParentMenu(e.element, 'dx-toolbar-menu-section'))
                        this.$nextTick(() => achaParentMenu(e.element, 'dx-popup-normal'))
                    }
                },
                acao: "logout",
                elementId: "menuSair",
                widget: 'dxButton',
            });

            return itensPerfil;

        },
        items() {
            let items = [];
            let _this = this;
            this.repaint

            let itensMenu = this.menus;

            let itensMenuCompact = [{
                items: itensMenu,
                template: function () {
                    return `
                            <i style="margin-left: 10px" class="fas fa-bars"/>
                        `;
                }
            }]

            //menu compacto
            // if(this.isCompact)
            //     items.push({
            //         visible: this.isCompact,
            //         location: "before",
            //         locateInMenu: "never",    
            //         widget: "dxMenu",
            //         options: {
            //             onItemRendered(e) {
            //                 if (e.itemData) {
            //                     e.itemElement.id = e.itemData.elementId
            //                     if (e.itemData.path && e.itemData.path != "#") {
            //                         _this.configuraAbrirNovaAba(e.itemElement, e.itemData.path)
            //                         _this.configuraRouteChange(e.itemElement, e.itemData.path)
            //                     }
            //                 }                            
            //             },
            //             dataSource: itensMenuCompact,
            //             displayExpr: "nome",
            //             showFirstSubmenuMode: "onHover",
            //             cssClass: "menu-aplicacao"                        
            //         }
            //     });

            //menu grande
            //-- before --
            //paineis
            items.push({
                visible: !this.isCompact,
                location: "before",
                locateInMenu: "never",
                widget: "dxMenu",
                options: {
                    adaptivityEnabled: false,
                    dataSource: [{
                        nome: this.$vistra.globalize("menu-paineis"),
                        path: "#",
                        elementId: "menuPaineis",
                        onClick: () => this.abrePaineis = true
                    }],
                    displayExpr: "nome",
                    showFirstSubmenuMode: "onHover",
                    cssClass: "menu-aplicacao",
                    onItemRendered(e) {
                        let titleEL = e.element.querySelector('.dx-menu-item-text');
                        if (titleEL) {
                            titleEL.style.display = 'flex'
                            titleEL.style.alignItems = 'center'
                            titleEL.innerHTML = `<svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 13.5H3C2.73478 13.5 2.48043 13.6054 2.29289 13.7929C2.10536 13.9804 2 14.2348 2 14.5C2 14.7652 2.10536 15.0196 2.29289 15.2071C2.48043 15.3946 2.73478 15.5 3 15.5H13C13.2652 15.5 13.5196 15.3946 13.7071 15.2071C13.8946 15.0196 14 14.7652 14 14.5C14 14.2348 13.8946 13.9804 13.7071 13.7929C13.5196 13.6054 13.2652 13.5 13 13.5ZM21 8.5H3C2.73478 8.5 2.48043 8.60536 2.29289 8.79289C2.10536 8.98043 2 9.23478 2 9.5C2 9.76522 2.10536 10.0196 2.29289 10.2071C2.48043 10.3946 2.73478 10.5 3 10.5H21C21.2652 10.5 21.5196 10.3946 21.7071 10.2071C21.8946 10.0196 22 9.76522 22 9.5C22 9.23478 21.8946 8.98043 21.7071 8.79289C21.5196 8.60536 21.2652 8.5 21 8.5Z" fill="#6FAD28"/>
                                </svg>
                                ` + titleEL.innerHTML
                        }
                        if (e.itemData) {
                            e.itemElement.id = e.itemData.elementId
                            if (e.itemData.path && e.itemData.path != "#") {
                                _this.configuraAbrirNovaAba(e.itemElement, e.itemData.path)
                                _this.configuraRouteChange(e.itemElement, e.itemData.path)
                            }
                        }
                    }
                }
            });

            //-- center --
            //logo
            items.push({
                //location: _this.isCompact ? "center" : "before",
                location: "center",
                locateInMenu: "never",
                widget: "dxButton",
                options: {
                    stylingMode: "text",
                    activeStateEnabled: false,
                    focusStateEnabled: false,
                    hoverStateEnabled: false,
                    height: 'auto',
                    width: 'auto',
                    onInitialized: function (e) {
                        _this.configuraAbrirNovaAba(e.element, '/')
                        _this.configuraRouteChange(e.element, '/')
                    },
                    template: function () {
                        return `
                                <div class="logo-menu">
                                    <img src="${_this.logos[_this.logoMenu]}" width="125" alt="" class="hidden-xs" ${_this.isCompact ? `style="margin: 0 auto` : ``} ">                                
                                </div>`;
                    },
                }

            });

            //-- after --
            if (!this.isCompact) {
                items.push({
                    location: "after",
                    locateInMenu: "never",
                    widget: "dxLoadIndicator",
                    disabled: true,
                    options: {
                        adaptivityEnabled: false,
                        visible: this.loadingMenus,
                        height: "20",
                        width: "20",
                        displayExpr: "nome",
                        cssClass: "loading",
                    }
                });
                items.push({
                    location: "after",
                    locateInMenu: "never",
                    widget: "dxMenu",
                    options: {
                        adaptivityEnabled: false,
                        dataSource: [{
                            nome: this.$vistra.globalize("menu-gerenciar"),
                            icon: this.usarIconePrimario && "fal fa-cog",
                            path: "#",
                            visible: this.showMenuGerenciar,
                            items: itensMenu,
                            elementId: "menuGerenciar"
                        }],
                        displayExpr: "nome",
                        showFirstSubmenuMode: "onHover",
                        cssClass: "menu-botao-gerenciar",
                        onItemRendered(e) {
                            let subMenuGerenciar = e.element.querySelector('.dx-submenu');
                            if (subMenuGerenciar) {
                                subMenuGerenciar.classList.add('estilizaMenuGerenciar')
                                subMenuGerenciar.style = 'border: 1px; border-radius: 5px;'
                            }
                            if (e.itemIndex == 0) {
                                let titleEL = e.element.querySelector('.dx-menu-item-text')
                                if (!titleEL.querySelector('i'))
                                    titleEL.innerHTML += '<i style="font-size: 10px" class="ml-2 fa-regular fa-angle-down"></i>'
                            }
                            if (e.itemData) {
                                e.itemElement.id = e.itemData.elementId
                                if (e.itemData.path && e.itemData.path != "#") {
                                    _this.configuraAbrirNovaAba(e.itemElement, e.itemData.path)
                                    _this.configuraRouteChange(e.itemElement, e.itemData.path)
                                }
                            }
                        },
                        onItemClick(e) {
                            switch (e.itemData.acao) {
                                case "editarPerfil":
                                    _this.editandoPerfil = true;
                                    break;
                                case "alterarEmpresaContexto":
                                    _this.$store.dispatch("empresaContexto", e.itemData.idEmpresa);
                                    break;
                                case "ajuda":
                                    _this.$vistra.abreAjuda({ desenvolvedor: _this.usuario.perfil === 11 });
                                    //teste 
                                    //_this.$vistra.abreAjuda({artigo: '468530ee-d92b-4047-b55d-8d280fde13eb'})
                                    //_this.$vistra.abreAjuda({categoria: '3ce37595-c5de-4c82-96df-a3f187bf8f00'})
                                    break;
                                case "logout":
                                    _this.logout()
                                    break;
                            }
                        },
                        onSubmenuShown: (e) => {

                        }
                    }
                })
                
            }

            return items;
        },

        colappsedClass() {
            let res = [];
            if (this.isFullPage)
                res.push('full-page')
            if (this.menu_collapsed)
                res.push('collapsed');
            return res;
        },
        colappsedChevron() {
            return this.menu_collapsed ? 'fa-chevron-down' : 'fa-chevron-up';
        }, 
        listNotifications() {
            let list = this.linkChangeLogs.length > 0 ? this.linkChangeLogs : []
            return list;        
        },

    },
    created() {
        this.windowWidth = window.innerWidth
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth
        })

        this.logoTema();
        this.carregaMenus()
        // console.log('Menu criado :)')

    },
    beforeMount() {
        this.menu_collapsed = !this.isMenuVisible;
    },
    async mounted() {

        this.setMenuHeight(this.menu_collapsed);
        let response = await this.$http.get(`/Logos/GetLogoPersonalizada`)
        this.logoPersonalizadas = response.data === "True";
        this.ProcessaChangeLogs();

    },
    methods: {
        ...mapActions(['carregaLogo']),
        ...mapMutations(["setRequisitaToggleMenu"]),
        fechaPaineis() {
            this.abrePaineis = false
            this.paineisJaAberto = true
        },
        fechaRelatorios() {
            this.abreRelatorios = false
        },
        fechaFormularios() {
            this.abreFormularios = false
        },
        resetarVisibilidadeGrupos() {
            this.modalEditGrupos = false
            this.$emit('atualizaGrupos');
        },
        abrirEditarGrupos() {
            this.modalEditGrupos = true;
        },
        logout() {
            this.$router.push({ name: 'login' })
        },
        direcionaMinhaConta() {
            this.$router.push({ name: 'perfil' })
            this.toggleMenuMobile()
        },
        direcionaSnapshots() {
            this.$router.push({ name: 'snapshots' })
            this.toggleMenuMobile()
        },
        toggleMenuMobile() {
            this.$refs.drawerMenu?.toggle();
        },
        onContentReady(e) {
            let button = e.element.querySelector(".dx-toolbar-menu-container .dx-dropdownmenu-button")
            if (button) {
                button.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.7105 12.7101C16.6909 11.9388 17.4065 10.881 17.7577 9.68407C18.109 8.48709 18.0784 7.21039 17.6703 6.03159C17.2621 4.85279 16.4967 3.83052 15.4806 3.10698C14.4644 2.38344 13.2479 1.99463 12.0005 1.99463C10.753 1.99463 9.5366 2.38344 8.52041 3.10698C7.50423 3.83052 6.73883 4.85279 6.3307 6.03159C5.92257 7.21039 5.892 8.48709 6.24325 9.68407C6.59449 10.881 7.31009 11.9388 8.29048 12.7101C6.61056 13.3832 5.14477 14.4995 4.04938 15.94C2.95398 17.3806 2.27005 19.0914 2.07048 20.8901C2.05604 21.0214 2.0676 21.1543 2.10451 21.2812C2.14142 21.408 2.20295 21.5264 2.2856 21.6294C2.4525 21.8376 2.69527 21.971 2.96049 22.0001C3.2257 22.0293 3.49164 21.9519 3.69981 21.785C3.90798 21.6181 4.04131 21.3753 4.07049 21.1101C4.29007 19.1553 5.22217 17.3499 6.6887 16.0389C8.15524 14.7279 10.0534 14.0032 12.0205 14.0032C13.9876 14.0032 15.8857 14.7279 17.3523 16.0389C18.8188 17.3499 19.7509 19.1553 19.9705 21.1101C19.9977 21.3558 20.1149 21.5828 20.2996 21.7471C20.4843 21.9115 20.7233 22.0016 20.9705 22.0001H21.0805C21.3426 21.97 21.5822 21.8374 21.747 21.6314C21.9119 21.4253 21.9886 21.1625 21.9605 20.9001C21.76 19.0963 21.0724 17.3811 19.9713 15.9383C18.8703 14.4955 17.3974 13.3796 15.7105 12.7101ZM12.0005 12.0001C11.2094 12.0001 10.436 11.7655 9.7782 11.326C9.12041 10.8865 8.60772 10.2618 8.30497 9.53086C8.00222 8.79995 7.923 7.99569 8.07734 7.21976C8.23168 6.44384 8.61265 5.73111 9.17206 5.1717C9.73147 4.61229 10.4442 4.23132 11.2201 4.07698C11.996 3.92264 12.8003 4.00186 13.5312 4.30461C14.2621 4.60736 14.8868 5.12005 15.3264 5.77784C15.7659 6.43564 16.0005 7.209 16.0005 8.00012C16.0005 9.06099 15.5791 10.0784 14.8289 10.8286C14.0788 11.5787 13.0614 12.0001 12.0005 12.0001Z" fill="currentColor"/>
                                    </svg>
                                    `
            }
        },
        getItensPerfil() {
            let itensPerfil = [{
                cssClass: "menu-sistema-perfil",
                icon: "fal fa-user-edit",
                nome: this.$vistra.globalize("menu-perfil"),
                acao: "editarPerfil",
                elementId: "perfilUsuario"
            }];

            if (this.empresas.length > 1 || !this.usuario.idsEmpresas.length)
                itensPerfil.push({
                    cssClass: "menu-sistema-perfil",
                    nome: this.$vistra.globalize("menu-empresa"),
                    icon: "fal fa-building",
                    path: "#",
                    items: this.empresas.map(e => {
                        return {
                            nome: e.nome,
                            icon:
                                String(e.id) === String(this.idEmpresa)
                                    ? "fal fa-check"
                                    : "",
                            acao: "alterarEmpresaContexto",
                            idEmpresa: e.id,
                            elementId: "menuEmpresa" + e.id
                        };
                    })
                });

            // remover essa condição após liberar o app de documentação na central
            // if (window.isDebug) {
            itensPerfil.push({
                cssClass: "menu-sistema-perfil",
                icon: "fal fa-question-circle",
                nome: this.$vistra.globalize("menu-ajuda"),
                acao: "ajuda",
                elementId: "menuAjuda"
            });
            // }

            itensPerfil.push({
                cssClass: "menu-sistema-perfil",
                icon: "fal fa-sign-out",
                nome: this.$vistra.globalize("menu-desconectar"),
                acao: "logout",
                elementId: "menuSair"
            });

            return [{
                items: itensPerfil,
                icon: "fal fa-user"
            }]
        },
        logoTema() {
            if (this.$vistra.estaNoModoEscuro()) {
                this.carregaLogo(2)
                return
            }
            this.carregaLogo(3)
        },
        async carregaMenus() {
            this.loadingMenus = true;
            this.menus = [];

            let dadosMenuResponse = await this.$http.get("/menu");

            let urlReportConfigurada = !!dadosMenuResponse.data?.moduloRelatoriosConfigurado;
            let permissoes = dadosMenuResponse.data?.permissoes;
            let qtdFormulariosVisiveis = dadosMenuResponse.data?.qtdFormulariosVisiveis ?? 0;

            this.setItensDesenvolvedor(urlReportConfigurada);
            this.setItensRelatorio(urlReportConfigurada);
            this.setItemsSnapshot();
            this.setItemsAgendamento();
            this.setItemsOpcoes(permissoes, urlReportConfigurada);
            this.setItemsFormulario(qtdFormulariosVisiveis);

            this.loadingMenus = false;
        },
        configuraAbrirNovaAba(element, path) {
            element.addEventListener('mousedown', function (event) {
                if (event.which == eventoCliqueBotaoDoMeio) {
                    event.preventDefault()
                    setTimeout(() => {
                        window.open(path)
                    }, 100)
                }
            })
        },
        configuraRouteChange(element, path, params) {
            let _this = this;
            element.addEventListener('click', function (event) {
                _this.$router.push(path)
            })
        },
        async getPermissoes() {
            let permissoesResponse = await this.$http.get("/PerfilUsuario/GetPermissoesOpcoes/");
            let permissoes = permissoesResponse.data;
            if (permissoes) {
                permissoes.usuario = this.usuario.id;
            }
            this.$vistra.Contexto.setLocalStorageItem("PERMISSOES_NAVBAR_OPCOES", JSON.stringify(permissoes))
            return permissoes;
        },
        setItemsOpcoes(permissoes, urlReportConfigurada) {
            let permissoesLocalStorage = JSON.parse(this.$vistra.Contexto.getLocalStorageItem("PERMISSOES_NAVBAR_OPCOES"));

            if (permissoes && permissoes != permissoesLocalStorage && typeof permissoes.message != "string") {
                this.criaItensOpcoes(this.menus, permissoes, urlReportConfigurada)
            }
            else if (permissoesLocalStorage && !permissoesLocalStorage.msgErro && typeof permissoesLocalStorage.message != "string") {
                this.criaItensOpcoes(this.menus, permissoesLocalStorage, urlReportConfigurada)
            }
        },
        criaItensOpcoes(menuItems, permissoes, urlReportConfigurada) {
            /**************************************
             ***********  Opções => Configurações
            **************************************/
            let itemsOpcoes = []
            let menuOpcoesConfiguracoes = {
                nome: this.$vistra.globalize("menu-configuracoes"),
                icon: this.usarIcone && "fal fa-sliders-h",
                path: '#',
                items: [],
                elementId: "menuOpcoesConfiguracoes"
            };
            if (permissoes.configuracoesGeral.visualizar == 1) {
                menuOpcoesConfiguracoes.items.push({
                    nome: this.$vistra.globalize("menu-configuracoes-geral"),
                    icon: this.usarIcone && "fal fa-cogs",
                    path: "/configuracoes/geral",
                    elementId: "menuOpcoesConfiguracoesGeral"
                });
            }

            if (permissoes.configuracoesCadastroLogos.visualizar == 1 && this.logoPersonalizadas) {
                menuOpcoesConfiguracoes.items.push({
                    nome: this.$vistra.globalize("menu-configuracoes-cadastro-logos"),
                    icon: this.usarIcone && "fal fa-image",
                    path: "/configuracoes/cadastrologos",
                    elementId: "menuOpcoesConfiguracoesLogos"
                })
            }

            if (permissoes.configuracoesEmail.visualizar == 1) {
                menuOpcoesConfiguracoes.items.push({
                    nome: this.$vistra.globalize("menu-configuracoes-email"),
                    icon: this.usarIcone && "fal fa-envelope",
                    path: "/configuracoes/email",
                    elementId: "menuOpcoesConfiguracoesEmail"
                })
            }

            if (permissoes.configuracoesVistra4?.visualizar == 1) {
                menuOpcoesConfiguracoes.items.push({
                    nome: this.$vistra.globalize("menu-configuracoes-vistra-4"),
                    icon: this.usarIcone && "fal fa-desktop",
                    onClick: async () => {
                        let acesso = await this.$http.get("/Usuario/GetAcessoPortal")
                        if (acesso.data.msgErro) {
                            this.$vistra.showMessage(acesso.data.msgErro)
                            return
                        }
                        let params = {
                            vistra_user_login: acesso.data.usuario,
                            vistra_user_password: acesso.data.senha,
                            vistra_url: `${acesso.data.urlAplicacao}/PRO/Paginas/Configuracoes/ConfiguradorSistema/Geral.aspx`,
                            vistra_crm: true
                        }
                        var form = document.createElement("form");
                        form.setAttribute("method", "post");
                        form.setAttribute("action", acesso.data.urlAplicacao + "/Login.aspx");
                        form.target = "_blank";
                        for (var key in params) {
                            if (params.hasOwnProperty(key)) {
                                var hiddenField = document.createElement("input");
                                hiddenField.setAttribute("type", "hidden");
                                hiddenField.setAttribute("name", key);
                                hiddenField.setAttribute("value", params[key]);
                                form.appendChild(hiddenField);
                            }
                        }
                        document.body.appendChild(form);
                        form.submit();
                    },
                    elementId: "menuOpcoesConfiguracoesVistra4"
                })
            }

            if (permissoes.empresas.visualizar == 1) {
                menuOpcoesConfiguracoes.items.push({
                    nome: this.$vistra.globalize("menu-empresas"),
                    icon: this.usarIcone && "fal fa-building",
                    path: "/empresas",
                    elementId: "menuOpcoesEmpresas"
                });
            }

            if (menuOpcoesConfiguracoes.items.length > 0)
                itemsOpcoes.push(menuOpcoesConfiguracoes);

            /**************************************
             ***********  Opções => Ferramentas
            **************************************/

            let menuFerramentas = {
                nome: this.$vistra.globalize("menu-ferramentas"),
                icon: this.usarIcone && "fal fal fa-tools",
                path: '#',
                items: [],
                elementId: "menuOpcoesFerramentas"
            };

            if (permissoes.publicacoes && permissoes.publicacoes.visualizar == 1) {
                menuFerramentas.items.push({
                    nome: this.$vistra.globalize("menu-ferramentas-publicacoes"),
                    icon: this.usarIcone && "fal fa-globe-americas",
                    path: "/publicacoes",
                    elementId: "menuOpcoesFerramentasPublicacoes"
                });
            }

            if (permissoes.importacaoCenarios && permissoes.importacaoCenarios.visualizar == 1) {
                menuFerramentas.items.push({
                    nome: this.$vistra.globalize("menu-ferramentas-importacao-cenarios"),
                    icon: this.usarIcone && "fal fa-file-upload",
                    path: "/importacaocenarios",
                    elementId: "menuOpcoesFerramentasImportacao"
                });
            }

            if (permissoes.agendamentoBackup && permissoes.agendamentoBackup.visualizar == 1) {
                menuFerramentas.items.push({
                    nome: this.$vistra.globalize("menu-ferramentas-agendamento-backup"),
                    icon: this.usarIcone && "fal fa-hdd",
                    path: "/agendamentobackup",
                    elementId: "menuOpcoesFerramentasBackup"
                });
            }

            if (permissoes.traducaoPaineis && permissoes.traducaoPaineis.visualizar == 1) {
                menuFerramentas.items.push({
                    nome: this.$vistra.globalize("menu-ferramentas-traducao-paineis"),
                    icon: this.usarIcone && "fal fa-language",
                    path: "/traducaopaineis",
                    elementId: "menuOpcoesFerramentasTraducaoPaineis"
                });
            }
            if(urlReportConfigurada && (this.usuario.perfil == 11 || this.isUsuarioSupervisor)){
              menuFerramentas.items.push({
                nome: this.$vistra.globalize("menu-ferramentas-cabecalho-impressao"),
                icon: this.usarIcone && "fal fa-file-signature",
                path: "/cabecalhoimpressao",
                elementId: "menuOpcoesFerramentasCabecalhoImpressao"
              })
            }

            if (this.isUsuarioSupervisor) {
                menuFerramentas.items.push({
                    nome: this.$vistra.globalize("menu-ferramentas-logs"),
                    icon: this.usarIcone && "fal fa-table-list",
                    path: "/logs",
                    elementId: "menuOpcoesFerramentasLogs"
                });
            }

            if (menuFerramentas.items.length > 0)
                itemsOpcoes.push(menuFerramentas);

            /**************************************
             ***********  Opções => Conexões
            **************************************/
            let menuConexoes = {
                nome: this.$vistra.globalize("menu-conexoes"),
                icon: this.usarIcone && "fal fa-network-wired",
                path: '#',
                items: [],
                elementId: "menuOpcoesConexoes"
            };

            if (permissoes.conexoesInternas.visualizar == 1) {
                menuConexoes.items.push({
                    nome: this.$vistra.globalize("menu-conexoes-internas"),
                    icon: this.usarIcone && "fal fa-plug",
                    path: "/configuracoes/conexoesinternas",
                    elementId: "menuOpcoesConexoesInternas"
                });
            }

            if (permissoes.conexoesExternas.visualizar == 1) {
                menuConexoes.items.push({
                    nome: this.$vistra.globalize("menu-conexoes-externas"),
                    icon: this.usarIcone && "fal fa-plug",
                    path: "/configuracoes/conexoesexternas",
                    elementId: "menuOpcoesConexoesExternas"
                });
            }


            if (menuConexoes.items.length > 0)
                itemsOpcoes.push(menuConexoes);

            /**************************************
             ***********  Opções => Usuários
            **************************************/

            let menuUsuarios = {
                nome: this.$vistra.globalize("menu-usuarios"),
                icon: this.usarIcone && `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.2497 10.1833C10.6943 9.79845 11.051 9.32241 11.2954 8.78752C11.5398 8.25264 11.6663 7.67143 11.6663 7.08334C11.6663 5.97827 11.2274 4.91846 10.446 4.13706C9.66455 3.35566 8.60474 2.91667 7.49967 2.91667C6.39461 2.91667 5.3348 3.35566 4.5534 4.13706C3.77199 4.91846 3.33301 5.97827 3.33301 7.08334C3.333 7.67143 3.45951 8.25264 3.70395 8.78752C3.94838 9.32241 4.30503 9.79845 4.74967 10.1833C3.58312 10.7116 2.5934 11.5646 1.89882 12.6405C1.20425 13.7163 0.834234 14.9694 0.833008 16.25C0.833008 16.471 0.920805 16.683 1.07709 16.8393C1.23337 16.9955 1.44533 17.0833 1.66634 17.0833C1.88735 17.0833 2.09932 16.9955 2.2556 16.8393C2.41188 16.683 2.49967 16.471 2.49967 16.25C2.49967 14.9239 3.02646 13.6522 3.96414 12.7145C4.90182 11.7768 6.17359 11.25 7.49967 11.25C8.82576 11.25 10.0975 11.7768 11.0352 12.7145C11.9729 13.6522 12.4997 14.9239 12.4997 16.25C12.4997 16.471 12.5875 16.683 12.7438 16.8393C12.9 16.9955 13.112 17.0833 13.333 17.0833C13.554 17.0833 13.766 16.9955 13.9223 16.8393C14.0785 16.683 14.1663 16.471 14.1663 16.25C14.1651 14.9694 13.7951 13.7163 13.1005 12.6405C12.406 11.5646 11.4162 10.7116 10.2497 10.1833ZM7.49967 9.58334C7.00522 9.58334 6.52187 9.43672 6.11075 9.16201C5.69963 8.88731 5.37919 8.49686 5.18998 8.04005C5.00076 7.58323 4.95125 7.08057 5.04771 6.59561C5.14417 6.11066 5.38228 5.6652 5.73191 5.31557C6.08154 4.96594 6.527 4.72784 7.01195 4.63138C7.4969 4.53491 7.99957 4.58442 8.45638 4.77364C8.9132 4.96286 9.30364 5.28329 9.57835 5.69441C9.85305 6.10554 9.99967 6.58889 9.99967 7.08334C9.99967 7.74638 9.73628 8.38227 9.26744 8.85111C8.7986 9.31995 8.16272 9.58334 7.49967 9.58334ZM15.6163 9.85001C16.1496 9.24945 16.498 8.50755 16.6195 7.71362C16.741 6.91969 16.6304 6.10757 16.3011 5.37501C15.9718 4.64244 15.4378 4.02067 14.7634 3.58452C14.089 3.14838 13.3028 2.91646 12.4997 2.91667C12.2787 2.91667 12.0667 3.00447 11.9104 3.16075C11.7541 3.31703 11.6663 3.52899 11.6663 3.75001C11.6663 3.97102 11.7541 4.18298 11.9104 4.33926C12.0667 4.49554 12.2787 4.58334 12.4997 4.58334C13.1627 4.58334 13.7986 4.84673 14.2674 5.31557C14.7363 5.78441 14.9997 6.4203 14.9997 7.08334C14.9985 7.52104 14.8824 7.95076 14.6631 8.32952C14.4437 8.70829 14.1287 9.02282 13.7497 9.24167C13.6261 9.31294 13.5229 9.41473 13.45 9.53729C13.377 9.65985 13.3367 9.79909 13.333 9.94167C13.3295 10.0831 13.3621 10.2232 13.4277 10.3486C13.4933 10.4739 13.5898 10.5806 13.708 10.6583L14.033 10.875L14.1413 10.9333C15.1458 11.4098 15.9933 12.1633 16.5838 13.1053C17.1744 14.0472 17.4835 15.1383 17.4747 16.25C17.4747 16.471 17.5625 16.683 17.7188 16.8393C17.875 16.9955 18.087 17.0833 18.308 17.0833C18.529 17.0833 18.741 16.9955 18.8973 16.8393C19.0535 16.683 19.1413 16.471 19.1413 16.25C19.1482 14.9712 18.8279 13.7119 18.2109 12.5917C17.5939 11.4716 16.7008 10.5278 15.6163 9.85001Z" fill="currentColor"/>
                    </svg>
                    `,
                path: '#',
                items: [],
                elementId: "menuOpcoesUsuarios"
            };

            if (permissoes.usuariosUsuarios.visualizar == 1) {
                menuUsuarios.items.push({
                    nome: this.$vistra.globalize("menu-usuarios"),
                    icon: this.usarIcone && "fal fa-user",
                    path: "/usuarios",
                    elementId: "menuOpcoesUsuariosUsuarios"
                });
            }

            if (permissoes.usuariosPerfis.visualizar == 1) {
                menuUsuarios.items.push({
                    nome: this.$vistra.globalize("menu-perfis-usuarios"),
                    icon: this.usarIcone && "fal fa-users-class",
                    path: "/perfisusuarios",
                    elementId: "menuOpcoesUsuariosPerfis"
                });
            }

            if (permissoes.usuariosVariaveis.visualizar == 1) {
                menuUsuarios.items.push({
                    nome: this.$vistra.globalize("menu-variaveis-usuarios"),
                    icon: this.usarIcone && "fal fa-user-cog",
                    path: "/variaveisusuarios",
                    elementId: "menuOpcoesUsuariosVariaveis"
                });
            }

            if (menuUsuarios.items.length > 0)
                itemsOpcoes.push(menuUsuarios);

            /**************************************/


            let opcoes = this.menus.find(menu => menu.elementId == "menuOpcoes")
            if (!!opcoes)
                menuItems.splice(this.menus.indexOf(opcoes), 1)

            if (itemsOpcoes.length > 0) {
                menuItems.push(...itemsOpcoes)
            }

            this.repintaMenu();
        },
        setItensDesenvolvedor(mostrarMenuRelatorios) {
            if (this.usuario.perfil === 11) { //dev
                let itensFilhosMenuDesenvolvedor = [
                    {
                        nome: this.$vistra.globalize("menu-origensdados"),
                        icon: this.usarIcone && "fal fa-brackets-curly",
                        path: "/origensdados",
                        elementId: "menuDesenvolvedorOrigensDados",
                        widget: 'dxButton',
                    },
                    {
                        nome: this.$vistra.globalize("menu-seletores"),
                        icon: this.usarIcone && "fal fa-list",
                        path: "/seletores",
                        elementId: "menuDesenvolvedorSeletores",
                        widget: 'dxButton',
                    },
                    {
                        nome: this.$vistra.globalize("menu-paleta"),
                        icon: this.usarIcone && "fal fa-paint-brush",
                        path: "/paletadecores",
                        elementId: "menuDesenvolvedorPaletasDeCores",
                        widget: 'dxButton'
                    },
                    {
                        nome: this.$vistra.globalize("menu-paineis"),
                        icon: this.usarIcone && "fal fa-desktop",
                        path: "/paineis-dev",
                        elementId: "menuDesenvolvedorPaineis",
                        widget: 'dxButton'
                    },
                    {
                        nome: this.$vistra.globalize("menu-formularios-dev"),
                        icon: this.usarIcone && `
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.59134 7.74167C5.51387 7.66356 5.4217 7.60157 5.32015 7.55926C5.21861 7.51696 5.10968 7.49517 4.99967 7.49517C4.88966 7.49517 4.78074 7.51696 4.67919 7.55926C4.57764 7.60157 4.48548 7.66356 4.40801 7.74167C4.33214 7.82092 4.27267 7.91438 4.23301 8.01667C4.16919 8.16843 4.15176 8.33569 4.1829 8.49735C4.21405 8.65901 4.29238 8.80782 4.40801 8.925C4.48901 8.99861 4.58202 9.0578 4.68301 9.10001C4.78191 9.14666 4.89036 9.16949 4.99967 9.16667C5.13616 9.16599 5.27039 9.1318 5.39057 9.0671C5.51074 9.00239 5.61319 8.90916 5.6889 8.7956C5.76461 8.68203 5.81126 8.55161 5.82477 8.41579C5.83827 8.27998 5.81821 8.14292 5.76634 8.01667C5.72668 7.91438 5.66721 7.82092 5.59134 7.74167ZM8.33301 9.16667C8.46949 9.16599 8.60372 9.1318 8.7239 9.0671C8.84408 9.00239 8.94652 8.90916 9.02223 8.7956C9.09794 8.68203 9.1446 8.55161 9.1581 8.41579C9.1716 8.27998 9.15154 8.14292 9.09967 8.01667C9.06001 7.91438 9.00054 7.82092 8.92467 7.74167C8.8293 7.64265 8.7109 7.56876 8.58004 7.52659C8.44918 7.48443 8.30992 7.47529 8.17467 7.50001C8.11948 7.50773 8.06596 7.52463 8.01634 7.55001L7.86634 7.625L7.74134 7.72501C7.58511 7.88888 7.49849 8.10693 7.49967 8.33334C7.49967 8.55435 7.58747 8.76631 7.74375 8.92259C7.90003 9.07887 8.11199 9.16667 8.33301 9.16667ZM5.31634 10.9C5.11346 10.8167 4.88589 10.8167 4.68301 10.9C4.53082 10.9625 4.40055 11.0687 4.30861 11.2051C4.21666 11.3416 4.16716 11.5022 4.16634 11.6667C4.16702 11.8032 4.20121 11.9374 4.26592 12.0576C4.33062 12.1777 4.42385 12.2802 4.53741 12.3559C4.65098 12.4316 4.7814 12.4783 4.91722 12.4918C5.05304 12.5053 5.19009 12.4852 5.31634 12.4333C5.41733 12.3911 5.51034 12.3319 5.59134 12.2583C5.66858 12.1805 5.72968 12.0881 5.77115 11.9866C5.81262 11.8851 5.83364 11.7763 5.83301 11.6667C5.83364 11.557 5.81262 11.4483 5.77115 11.3467C5.72968 11.2452 5.66858 11.1529 5.59134 11.075C5.51312 10.9978 5.41938 10.9382 5.31634 10.9ZM11.6663 10.8333H8.33301C8.11199 10.8333 7.90003 10.9211 7.74375 11.0774C7.58747 11.2337 7.49967 11.4457 7.49967 11.6667C7.49967 11.8877 7.58747 12.0996 7.74375 12.2559C7.90003 12.4122 8.11199 12.5 8.33301 12.5H11.6663C11.8874 12.5 12.0993 12.4122 12.2556 12.2559C12.4119 12.0996 12.4997 11.8877 12.4997 11.6667C12.4997 11.4457 12.4119 11.2337 12.2556 11.0774C12.0993 10.9211 11.8874 10.8333 11.6663 10.8333ZM12.258 7.74167C12.1805 7.66356 12.0884 7.60157 11.9868 7.55926C11.8853 7.51696 11.7764 7.49517 11.6663 7.49517C11.5563 7.49517 11.4474 7.51696 11.3459 7.55926C11.2443 7.60157 11.1521 7.66356 11.0747 7.74167C10.9988 7.82092 10.9393 7.91438 10.8997 8.01667C10.8511 8.13074 10.8286 8.25421 10.8338 8.37808C10.839 8.50195 10.8718 8.6231 10.9297 8.7327C10.9877 8.8423 11.0694 8.93758 11.1688 9.01161C11.2683 9.08564 11.383 9.13654 11.5046 9.16061C11.6262 9.18468 11.7517 9.18131 11.8718 9.15075C11.992 9.12018 12.1038 9.0632 12.1991 8.98394C12.2945 8.90468 12.3709 8.80514 12.4229 8.69259C12.4749 8.58004 12.5011 8.45731 12.4997 8.33334C12.5025 8.22402 12.4797 8.11557 12.433 8.01667C12.3933 7.91438 12.3339 7.82092 12.258 7.74167ZM15.4663 10.975C15.4199 10.9435 15.3694 10.9182 15.3163 10.9C15.1135 10.8167 14.8859 10.8167 14.683 10.9C14.582 10.9422 14.489 11.0014 14.408 11.075C14.2557 11.2347 14.1694 11.446 14.1663 11.6667C14.1663 11.8877 14.2541 12.0996 14.4104 12.2559C14.5667 12.4122 14.7787 12.5 14.9997 12.5C15.2207 12.5 15.4326 12.4122 15.5889 12.2559C15.7452 12.0996 15.833 11.8877 15.833 11.6667C15.8299 11.446 15.7436 11.2347 15.5913 11.075L15.4663 10.975ZM16.6663 4.16667H3.33301C2.66997 4.16667 2.03408 4.43006 1.56524 4.8989C1.0964 5.36775 0.833008 6.00363 0.833008 6.66667V13.3333C0.833008 13.9964 1.0964 14.6323 1.56524 15.1011C2.03408 15.5699 2.66997 15.8333 3.33301 15.8333H16.6663C17.3294 15.8333 17.9653 15.5699 18.4341 15.1011C18.9029 14.6323 19.1663 13.9964 19.1663 13.3333V6.66667C19.1663 6.00363 18.9029 5.36775 18.4341 4.8989C17.9653 4.43006 17.3294 4.16667 16.6663 4.16667ZM17.4997 13.3333C17.4997 13.5544 17.4119 13.7663 17.2556 13.9226C17.0993 14.0789 16.8874 14.1667 16.6663 14.1667H3.33301C3.11199 14.1667 2.90003 14.0789 2.74375 13.9226C2.58747 13.7663 2.49967 13.5544 2.49967 13.3333V6.66667C2.49967 6.44566 2.58747 6.2337 2.74375 6.07742C2.90003 5.92114 3.11199 5.83334 3.33301 5.83334H16.6663C16.8874 5.83334 17.0993 5.92114 17.2556 6.07742C17.4119 6.2337 17.4997 6.44566 17.4997 6.66667V13.3333ZM15.5913 7.74167C15.4748 7.62415 15.3259 7.544 15.1636 7.51144C15.0013 7.47888 14.833 7.49539 14.6801 7.55886C14.5272 7.62233 14.3967 7.72989 14.3052 7.86783C14.2137 8.00576 14.1654 8.16782 14.1663 8.33334C14.1649 8.45731 14.1911 8.58004 14.2431 8.69259C14.2951 8.80514 14.3715 8.90468 14.4669 8.98394C14.5622 9.0632 14.674 9.12018 14.7942 9.15075C14.9143 9.18131 15.0398 9.18468 15.1614 9.16061C15.283 9.13654 15.3977 9.08564 15.4972 9.01161C15.5966 8.93758 15.6783 8.8423 15.7363 8.7327C15.7942 8.6231 15.827 8.50195 15.8322 8.37808C15.8374 8.25421 15.8149 8.13074 15.7663 8.01667C15.7267 7.91438 15.6672 7.82092 15.5913 7.74167Z" fill="currentColor"/>
                                    </svg>`,
                        path: "/formularios-dev",
                        elementId: "menuDesenvolvedorFormularios",
                    }
                ]

                if (mostrarMenuRelatorios) {
                    itensFilhosMenuDesenvolvedor.push({
                        nome: this.$vistra.globalize("menu-relatorios"),
                        icon: this.usarIcone && "fal fa-file-lines",
                        path: "/reports-dev",
                        elementId: "menuDesenvolvedorReports",
                        widget: 'dxButton'
                    })
                }

              this.menus.push({
                    nome: this.$vistra.globalize("menu-desenvolvedor"),
                    icon: this.usarIcone && "fa-light fa-display-code",
                    path: "#",
                    elementId: "menuDesenvolvedor",
                    widget: 'dxButton',
                    items: itensFilhosMenuDesenvolvedor
                });
            }
        },
        setItensRelatorio(urlReportConfigurada) {
          if (!urlReportConfigurada)
            return

          const itemRelatorio = {
            nome: this.$vistra.globalize("menu-relatorios"),
            icon: "fal fa-file-lines",
            elementId: "menuRelatorio",
            onClick: () => this.abreRelatorios = true
          }

          // Seta se o usuario for DEV seta abaixo do ITEM DESENVOLVEDOR, se for PRO seta acima
          this.usuario.perfil === 11 ? this.menus.push(itemRelatorio) : this.menus.unshift(itemRelatorio)
        },
        setItemsFormulario(qtdFormulariosVisiveis) {
            if (qtdFormulariosVisiveis) {
              this.menus.push({
                    nome: this.$vistra.globalize("menu-formularios"),
                    icon: this.usarIcone && `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.59134 7.74167C5.51387 7.66356 5.4217 7.60157 5.32015 7.55926C5.21861 7.51696 5.10968 7.49517 4.99967 7.49517C4.88966 7.49517 4.78074 7.51696 4.67919 7.55926C4.57764 7.60157 4.48548 7.66356 4.40801 7.74167C4.33214 7.82092 4.27267 7.91438 4.23301 8.01667C4.16919 8.16843 4.15176 8.33569 4.1829 8.49735C4.21405 8.65901 4.29238 8.80782 4.40801 8.925C4.48901 8.99861 4.58202 9.0578 4.68301 9.10001C4.78191 9.14666 4.89036 9.16949 4.99967 9.16667C5.13616 9.16599 5.27039 9.1318 5.39057 9.0671C5.51074 9.00239 5.61319 8.90916 5.6889 8.7956C5.76461 8.68203 5.81126 8.55161 5.82477 8.41579C5.83827 8.27998 5.81821 8.14292 5.76634 8.01667C5.72668 7.91438 5.66721 7.82092 5.59134 7.74167ZM8.33301 9.16667C8.46949 9.16599 8.60372 9.1318 8.7239 9.0671C8.84408 9.00239 8.94652 8.90916 9.02223 8.7956C9.09794 8.68203 9.1446 8.55161 9.1581 8.41579C9.1716 8.27998 9.15154 8.14292 9.09967 8.01667C9.06001 7.91438 9.00054 7.82092 8.92467 7.74167C8.8293 7.64265 8.7109 7.56876 8.58004 7.52659C8.44918 7.48443 8.30992 7.47529 8.17467 7.50001C8.11948 7.50773 8.06596 7.52463 8.01634 7.55001L7.86634 7.625L7.74134 7.72501C7.58511 7.88888 7.49849 8.10693 7.49967 8.33334C7.49967 8.55435 7.58747 8.76631 7.74375 8.92259C7.90003 9.07887 8.11199 9.16667 8.33301 9.16667ZM5.31634 10.9C5.11346 10.8167 4.88589 10.8167 4.68301 10.9C4.53082 10.9625 4.40055 11.0687 4.30861 11.2051C4.21666 11.3416 4.16716 11.5022 4.16634 11.6667C4.16702 11.8032 4.20121 11.9374 4.26592 12.0576C4.33062 12.1777 4.42385 12.2802 4.53741 12.3559C4.65098 12.4316 4.7814 12.4783 4.91722 12.4918C5.05304 12.5053 5.19009 12.4852 5.31634 12.4333C5.41733 12.3911 5.51034 12.3319 5.59134 12.2583C5.66858 12.1805 5.72968 12.0881 5.77115 11.9866C5.81262 11.8851 5.83364 11.7763 5.83301 11.6667C5.83364 11.557 5.81262 11.4483 5.77115 11.3467C5.72968 11.2452 5.66858 11.1529 5.59134 11.075C5.51312 10.9978 5.41938 10.9382 5.31634 10.9ZM11.6663 10.8333H8.33301C8.11199 10.8333 7.90003 10.9211 7.74375 11.0774C7.58747 11.2337 7.49967 11.4457 7.49967 11.6667C7.49967 11.8877 7.58747 12.0996 7.74375 12.2559C7.90003 12.4122 8.11199 12.5 8.33301 12.5H11.6663C11.8874 12.5 12.0993 12.4122 12.2556 12.2559C12.4119 12.0996 12.4997 11.8877 12.4997 11.6667C12.4997 11.4457 12.4119 11.2337 12.2556 11.0774C12.0993 10.9211 11.8874 10.8333 11.6663 10.8333ZM12.258 7.74167C12.1805 7.66356 12.0884 7.60157 11.9868 7.55926C11.8853 7.51696 11.7764 7.49517 11.6663 7.49517C11.5563 7.49517 11.4474 7.51696 11.3459 7.55926C11.2443 7.60157 11.1521 7.66356 11.0747 7.74167C10.9988 7.82092 10.9393 7.91438 10.8997 8.01667C10.8511 8.13074 10.8286 8.25421 10.8338 8.37808C10.839 8.50195 10.8718 8.6231 10.9297 8.7327C10.9877 8.8423 11.0694 8.93758 11.1688 9.01161C11.2683 9.08564 11.383 9.13654 11.5046 9.16061C11.6262 9.18468 11.7517 9.18131 11.8718 9.15075C11.992 9.12018 12.1038 9.0632 12.1991 8.98394C12.2945 8.90468 12.3709 8.80514 12.4229 8.69259C12.4749 8.58004 12.5011 8.45731 12.4997 8.33334C12.5025 8.22402 12.4797 8.11557 12.433 8.01667C12.3933 7.91438 12.3339 7.82092 12.258 7.74167ZM15.4663 10.975C15.4199 10.9435 15.3694 10.9182 15.3163 10.9C15.1135 10.8167 14.8859 10.8167 14.683 10.9C14.582 10.9422 14.489 11.0014 14.408 11.075C14.2557 11.2347 14.1694 11.446 14.1663 11.6667C14.1663 11.8877 14.2541 12.0996 14.4104 12.2559C14.5667 12.4122 14.7787 12.5 14.9997 12.5C15.2207 12.5 15.4326 12.4122 15.5889 12.2559C15.7452 12.0996 15.833 11.8877 15.833 11.6667C15.8299 11.446 15.7436 11.2347 15.5913 11.075L15.4663 10.975ZM16.6663 4.16667H3.33301C2.66997 4.16667 2.03408 4.43006 1.56524 4.8989C1.0964 5.36775 0.833008 6.00363 0.833008 6.66667V13.3333C0.833008 13.9964 1.0964 14.6323 1.56524 15.1011C2.03408 15.5699 2.66997 15.8333 3.33301 15.8333H16.6663C17.3294 15.8333 17.9653 15.5699 18.4341 15.1011C18.9029 14.6323 19.1663 13.9964 19.1663 13.3333V6.66667C19.1663 6.00363 18.9029 5.36775 18.4341 4.8989C17.9653 4.43006 17.3294 4.16667 16.6663 4.16667ZM17.4997 13.3333C17.4997 13.5544 17.4119 13.7663 17.2556 13.9226C17.0993 14.0789 16.8874 14.1667 16.6663 14.1667H3.33301C3.11199 14.1667 2.90003 14.0789 2.74375 13.9226C2.58747 13.7663 2.49967 13.5544 2.49967 13.3333V6.66667C2.49967 6.44566 2.58747 6.2337 2.74375 6.07742C2.90003 5.92114 3.11199 5.83334 3.33301 5.83334H16.6663C16.8874 5.83334 17.0993 5.92114 17.2556 6.07742C17.4119 6.2337 17.4997 6.44566 17.4997 6.66667V13.3333ZM15.5913 7.74167C15.4748 7.62415 15.3259 7.544 15.1636 7.51144C15.0013 7.47888 14.833 7.49539 14.6801 7.55886C14.5272 7.62233 14.3967 7.72989 14.3052 7.86783C14.2137 8.00576 14.1654 8.16782 14.1663 8.33334C14.1649 8.45731 14.1911 8.58004 14.2431 8.69259C14.2951 8.80514 14.3715 8.90468 14.4669 8.98394C14.5622 9.0632 14.674 9.12018 14.7942 9.15075C14.9143 9.18131 15.0398 9.18468 15.1614 9.16061C15.283 9.13654 15.3977 9.08564 15.4972 9.01161C15.5966 8.93758 15.6783 8.8423 15.7363 8.7327C15.7942 8.6231 15.827 8.50195 15.8322 8.37808C15.8374 8.25421 15.8149 8.13074 15.7663 8.01667C15.7267 7.91438 15.6672 7.82092 15.5913 7.74167Z" fill="currentColor"/>
                    </svg>`,
                    elementId: "menuFormularios",
                    onClick: () => this.abreFormularios = true
                })
            }
        },
        setItemsSnapshot() {
          this.menus.push({
            nome: this.$vistra.globalize("menu-snapshots"),
            icon: this.usarIcone && 'fal fa-camera-retro',
            path: "/snapshots",
            elementId: "menuSnapshots"
          });
          this.itensGerenciarMenuMobile.push({
            action: () => this.direcionaSnapshots(),
            label: this.$vistra.globalize("menu-snapshots"),
            icon: 'fal fa-camera-retro',
          })
        },
        setItemsAgendamento() {
          this.menus.push({
            nome: this.$vistra.globalize("menu-ferramentas-agendamentos"),
            icon: this.usarIcone && `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.0003 15.8333C10.1651 15.8333 10.3263 15.7845 10.4633 15.6929C10.6003 15.6013 10.7072 15.4712 10.7702 15.3189C10.8333 15.1666 10.8498 14.9991 10.8176 14.8374C10.7855 14.6758 10.7061 14.5273 10.5896 14.4107C10.473 14.2942 10.3246 14.2148 10.1629 14.1827C10.0013 14.1505 9.83369 14.167 9.68142 14.2301C9.52915 14.2932 9.399 14.4 9.30743 14.537C9.21587 14.6741 9.16699 14.8352 9.16699 15C9.16699 15.221 9.25479 15.433 9.41107 15.5893C9.56735 15.7455 9.77931 15.8333 10.0003 15.8333ZM14.167 15.8333C14.3318 15.8333 14.4929 15.7845 14.63 15.6929C14.767 15.6013 14.8738 15.4712 14.9369 15.3189C15 15.1666 15.0165 14.9991 14.9843 14.8374C14.9522 14.6758 14.8728 14.5273 14.7562 14.4107C14.6397 14.2942 14.4912 14.2148 14.3296 14.1827C14.1679 14.1505 14.0004 14.167 13.8481 14.2301C13.6958 14.2932 13.5657 14.4 13.4741 14.537C13.3825 14.6741 13.3337 14.8352 13.3337 15C13.3337 15.221 13.4215 15.433 13.5777 15.5893C13.734 15.7455 13.946 15.8333 14.167 15.8333ZM14.167 12.5C14.3318 12.5 14.4929 12.4511 14.63 12.3596C14.767 12.268 14.8738 12.1378 14.9369 11.9856C15 11.8333 15.0165 11.6657 14.9843 11.5041C14.9522 11.3424 14.8728 11.194 14.7562 11.0774C14.6397 10.9609 14.4912 10.8815 14.3296 10.8493C14.1679 10.8172 14.0004 10.8337 13.8481 10.8968C13.6958 10.9598 13.5657 11.0667 13.4741 11.2037C13.3825 11.3407 13.3337 11.5019 13.3337 11.6667C13.3337 11.8877 13.4215 12.0996 13.5777 12.2559C13.734 12.4122 13.946 12.5 14.167 12.5ZM10.0003 12.5C10.1651 12.5 10.3263 12.4511 10.4633 12.3596C10.6003 12.268 10.7072 12.1378 10.7702 11.9856C10.8333 11.8333 10.8498 11.6657 10.8176 11.5041C10.7855 11.3424 10.7061 11.194 10.5896 11.0774C10.473 10.9609 10.3246 10.8815 10.1629 10.8493C10.0013 10.8172 9.83369 10.8337 9.68142 10.8968C9.52915 10.9598 9.399 11.0667 9.30743 11.2037C9.21587 11.3407 9.16699 11.5019 9.16699 11.6667C9.16699 11.8877 9.25479 12.0996 9.41107 12.2559C9.56735 12.4122 9.77931 12.5 10.0003 12.5ZM15.8337 2.5H15.0003V1.66667C15.0003 1.44566 14.9125 1.23369 14.7562 1.07741C14.6 0.921133 14.388 0.833336 14.167 0.833336C13.946 0.833336 13.734 0.921133 13.5777 1.07741C13.4215 1.23369 13.3337 1.44566 13.3337 1.66667V2.5H6.66699V1.66667C6.66699 1.44566 6.5792 1.23369 6.42291 1.07741C6.26663 0.921133 6.05467 0.833336 5.83366 0.833336C5.61265 0.833336 5.40068 0.921133 5.2444 1.07741C5.08812 1.23369 5.00033 1.44566 5.00033 1.66667V2.5H4.16699C3.50395 2.5 2.86807 2.76339 2.39923 3.23224C1.93038 3.70108 1.66699 4.33696 1.66699 5V16.6667C1.66699 17.3297 1.93038 17.9656 2.39923 18.4344C2.86807 18.9033 3.50395 19.1667 4.16699 19.1667H15.8337C16.4967 19.1667 17.1326 18.9033 17.6014 18.4344C18.0703 17.9656 18.3337 17.3297 18.3337 16.6667V5C18.3337 4.33696 18.0703 3.70108 17.6014 3.23224C17.1326 2.76339 16.4967 2.5 15.8337 2.5ZM16.667 16.6667C16.667 16.8877 16.5792 17.0996 16.4229 17.2559C16.2666 17.4122 16.0547 17.5 15.8337 17.5H4.16699C3.94598 17.5 3.73402 17.4122 3.57774 17.2559C3.42146 17.0996 3.33366 16.8877 3.33366 16.6667V9.16667H16.667V16.6667ZM16.667 7.5H3.33366V5C3.33366 4.77899 3.42146 4.56703 3.57774 4.41075C3.73402 4.25447 3.94598 4.16667 4.16699 4.16667H5.00033V5C5.00033 5.22102 5.08812 5.43298 5.2444 5.58926C5.40068 5.74554 5.61265 5.83334 5.83366 5.83334C6.05467 5.83334 6.26663 5.74554 6.42291 5.58926C6.5792 5.43298 6.66699 5.22102 6.66699 5V4.16667H13.3337V5C13.3337 5.22102 13.4215 5.43298 13.5777 5.58926C13.734 5.74554 13.946 5.83334 14.167 5.83334C14.388 5.83334 14.6 5.74554 14.7562 5.58926C14.9125 5.43298 15.0003 5.22102 15.0003 5V4.16667H15.8337C16.0547 4.16667 16.2666 4.25447 16.4229 4.41075C16.5792 4.56703 16.667 4.77899 16.667 5V7.5ZM5.83366 12.5C5.99848 12.5 6.15959 12.4511 6.29663 12.3596C6.43368 12.268 6.54049 12.1378 6.60356 11.9856C6.66663 11.8333 6.68313 11.6657 6.65098 11.5041C6.61883 11.3424 6.53946 11.194 6.42291 11.0774C6.30637 10.9609 6.15789 10.8815 5.99623 10.8493C5.83458 10.8172 5.66703 10.8337 5.51476 10.8968C5.36248 10.9598 5.23234 11.0667 5.14077 11.2037C5.0492 11.3407 5.00033 11.5019 5.00033 11.6667C5.00033 11.8877 5.08812 12.0996 5.2444 12.2559C5.40068 12.4122 5.61265 12.5 5.83366 12.5ZM5.83366 15.8333C5.99848 15.8333 6.15959 15.7845 6.29663 15.6929C6.43368 15.6013 6.54049 15.4712 6.60356 15.3189C6.66663 15.1666 6.68313 14.9991 6.65098 14.8374C6.61883 14.6758 6.53946 14.5273 6.42291 14.4107C6.30637 14.2942 6.15789 14.2148 5.99623 14.1827C5.83458 14.1505 5.66703 14.167 5.51476 14.2301C5.36248 14.2932 5.23234 14.4 5.14077 14.537C5.0492 14.6741 5.00033 14.8352 5.00033 15C5.00033 15.221 5.08812 15.433 5.2444 15.5893C5.40068 15.7455 5.61265 15.8333 5.83366 15.8333Z" fill="currentColor"/>
                        </svg>
                        `,
            path: "/agendamentos",
            elementId: "menuOpcoesFerramentasAgendamentos"
          });
        },
        collapseMenu() {
            this.setMenuHeight(!this.menu_collapsed);
            setTimeout(() => {
                this.menu_collapsed = !this.onRequisitaToggleMenu.open;
            }, this.menu_collapsed ? 0 : 500);
        },
        setMenuHeight(collapsed) {
            if (document.querySelector("#menu-sistema"))
                document.querySelector("#menu-sistema").style.height = collapsed ? (this.isFullPage ? '10px' : '0px') : null;
        },
        repintaMenu() {
            // this.repaint = Math.random()
            this.repaint = false
            setTimeout(() => {
                this.repaint = true
            }, 100)
        },
        abreChangeLog(url, index){
            if(this.listNotifications[index].visualizado){
                window.open(url, '_blank');
                return 
            }   
            this.listNotifications[index].visualizado = true
            this.$http.put('/UsuarioNotificacoesChangeLog/NotificacaoVisualizada/' + this.listNotifications[index].id);

            const elementMenuNotificacao = document.getElementsByClassName('menu-botao-notificacao')
            this.adicionaEstilizacaoIconBell(elementMenuNotificacao[0], this.listNotifications);
            window.open(url, '_blank');
        },
        timeAgo(dateString) {
            if(!dateString)
                return ""

            const now = new Date(); 
            const pastDate = new Date(dateString); 
            const diffInMs = now - pastDate; 

            const msPerMinute = 60 * 1000;
            const msPerHour = msPerMinute * 60;
            const msPerDay = msPerHour * 24;

            if (diffInMs < msPerHour) {
                const minutesAgo = Math.round(diffInMs / msPerMinute);
                return `${minutesAgo}m ${this.$vistra.globalize("menu-notificacao-atras")}`;
            } else if (diffInMs < msPerDay) {
                const hoursAgo = Math.round(diffInMs / msPerHour);
                return `${hoursAgo}h ${this.$vistra.globalize("menu-notificacao-atras")}`;
            } else {
                const daysAgo = Math.round(diffInMs / msPerDay);
                return `${daysAgo} ${this.$vistra.globalize("menu-dias-atras")}`;
            }
        },
        atualizaNumeroNotificacoes() {
            this.numberOfNotifications = this.linkChangeLogs?.filter(l => !l.visualizado).length || 0;
        },
        adicionaEstilizacaoIconBell(element, listNotifications = []){
            this.$nextTick(() => {
                const bellIcon = element?.querySelector(".fa-bell")
                if(!bellIcon)
                    return;
                let numberOfNotifications = this.getNumberNotificacao(listNotifications)

                if (bellIcon && numberOfNotifications > 0) {
                    let existingCircle = bellIcon.querySelector(".notification-circle");
                    if (existingCircle) {
                        existingCircle.remove(); 
                    }

                    const notificationCircle = document.createElement("div");
                    notificationCircle.classList.add("notification-circle");
        
                    notificationCircle.innerText = numberOfNotifications;

                    bellIcon.appendChild(notificationCircle);
                }
                else{
                    let existingCircle = bellIcon.querySelector(".notification-circle");
                    if (existingCircle) {
                        existingCircle.remove(); 
                    }
                }
            })
            
        },
        getNumberNotificacao(listNotifications){
            if(listNotifications.length > 0)
                return listNotifications.filter(l => !l.visualizado).length
            else
                return this.numberOfNotifications
        },
        ProcessaChangeLogs(){
          this.atualizaNumeroNotificacoes();
          const elementMenuNotificacao = document.getElementsByClassName('menu-botao-notificacao')
          this.adicionaEstilizacaoIconBell(elementMenuNotificacao[0]);
        }
    }

}
</script>

<style lang="scss">
.personaliza-menu-perfil {
    @apply bg-white dark:bg-gray-900 #{!important};
    @apply border-solid border-gray-100 dark:border-gray-700 #{!important};
}
.dx-submenu,
.estilizaMenuGerenciar {
    .dx-menu-items-container {
        .dx-menu-item-wrapper {

            .dx-item,
            .dx-menu-item,
            .dx-menu-item-has-text,
            .dx-menu-item-has-icon {

                .dx-submenu,
                .menu-botao-gerenciar {
                    border: 1px;
                    border-radius: 5px;
                    // @apply bg-white dark:bg-gray-800 #{!important};
                    @apply border-solid border-gray-100 dark:border-gray-900 #{!important};
                }
            }
        }
    }
}

.notification-circle {
    position: absolute;
    top: 13px;  /* Ajuste conforme necessário */
    right: -1px;  /* Ajuste conforme necessário */
    width: 21px;
    height: 21px;
    background-color: rgb(74, 174, 20);
    border-radius: 50%;
    color: white; 
    font-size: 10px;
    text-align: center;
    line-height: 16px; 

    @apply border-2 border-solid border-white dark:border-[#1A2B36] #{!important};
}

.estilizaMenuGerenciar {
    position: relative;
    right: 80px;
    .dx-state-hover,
    .dx-state-active,
    .dx-menu-item-expanded,
    .dx-swatch-vistra-dark .dx-list-item.dx-state-active,
    .dx-swatch-vistra-dark .dx-list-item.dx-state-hover {
        // background-color: transparent !important;
        @apply text-primary-500 #{!important};
    }

    // @apply bg-white dark:bg-gray-800 #{!important};
    @apply border-solid border-gray-100 dark:border-gray-900 #{!important};
}

.menu-perfil-personalizado .dx-popup-content {
    border: 1px;
    border-radius: 5px;
    @apply border-gray-100 dark:border-gray-800 #{!important};
}

.menu-perfil-personalizado,
.menu-aplicacao {

    .dx-state-hover,
    .dx-menu-item-expanded,
    .dx-list-item.dx-state-active,
    .dx-list-item.dx-state-hover,
    .dx-list-item.dx-state-hover .dx-button-content,
    .dx-list-item.dx-state-hover .dx-button-content i {
        background-color: transparent !important;
        @apply text-primary-500 #{!important};
    }

    .dx-menu-item {
        @apply transition-all duration-300 ease-in-out;
    }
}

.dx-context-menu .dx-menu-items-container {
    //padding: 0px !important;
}

#menu-sistema {

    // #toolbar {
    //     border-bottom: none !important;
    // }
    .menu-sistema-container {
        padding: 0 22px;
    }

    // @import '@/styles/base.scss';
    .dx-menu-item {
        @apply transition-all duration-300 ease-in-out;
    }

    .dx-button {
        background-color: transparent !important;
    }

    .dx-widget {
        font-size: 14px !important;
        @apply dark:text-white;
    }

    .dx-state-hover,
    .dx-state-active,
    .dx-menu-item-expanded,
    .dx-swatch-vistra-dark .dx-list-item.dx-state-active,
    .dx-swatch-vistra-dark .dx-list-item.dx-state-hover {
        background-color: transparent !important;
        @apply text-primary-500 #{!important};
    }

    .dx-menu-item,
    .dx-item {
        font-size: 14px !important;
        @apply dark:text-white;
        font-weight: 400 !important;
        margin-top: 7px !important;
    }

    .dx-toolbar-menu-container .dx-dropdownmenu-button {
        height: 27px !important;
        margin-right: 12px;

        svg {
            margin: 0 auto;
        }
    }

    .dx-button-content {
        padding: 0px !important
    }

    .logo-menu {
        // height: 50px;
        margin-left: 30px;
        display: flex;
        cursor: pointer;

        img {
            object-fit: contain;
            max-height: 50px;
            max-width: 185px;
            height: auto;
            width: auto;
            overflow: hidden;
            margin: auto;
            cursor: pointer;
        }
    }

    .dx-menu.menu-aplicacao-perfil .dx-item-content.dx-menu-item-content {
        padding: 2px 12px 2px 4px !important;
    }

    @media (max-width: 1024px) {
        .menu-mobile {

            .hamb {
                @apply flex #{!important};
            }

            .is-hide-on-mob {
                @apply hidden;
            }

        }
    }
}

.dx-list-item-content.dx-texteditor,
.dx-list-item-content>.dx-texteditor,
.dx-toolbar-item-content.dx-texteditor,
.dx-toolbar-item-content>.dx-texteditor {
    margin-left: 11px;
    margin-right: 11px;
    width: 200px !important;
}

.dx-swatch-vistra-dark .dx-toolbar-menu-section .dx-list-item-content,
.dx-swatch-vistra-dark .dx-toolbar-menu-section .dx-toolbar-item-auto-hide,
.dx-toolbar-menu-section .dx-list-item-content,
.dx-toolbar-menu-section .dx-toolbar-item-auto-hide {
    padding: 0px !important;
}

.menu-aplicacao .dx-menu-item .dx-menu-item-content {
    padding-left: 10px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    height: 40px !important;
}

#menu-sistema .dx-toolbar-button .dx-menu .dx-menu-item {
    height: 40px !important;
}

.dx-submenu .dx-menu-item {
    min-width: 110px;
    @apply bg-white dark:bg-gray-800 #{!important};
}
</style>

<style lang="scss" scoped>
#menu-sistema {
    font-family: 'Quicksand', sans-serif;
    // @import '@/styles/base.scss';
    // height: var(--altura-barra-superior);

    position: relative;

    // &.anim {
    //     transition: height 0.5s;
    // }

    .navbar-defesa {
        position: absolute;
        bottom: 0px;
        height: 15px;
        margin-left: 0px;
        width: 35px;

        &.collapsed {
            display: none;
        }

        &.full-page {
            margin-left: 10px !important;
        }
    }

    .menu-collapser {
        position: absolute;
        bottom: -15px;
        width: 25px;

        margin-left: 0px;
        border-width: 1px;
        border-style: solid;

        border-bottom: 0px;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;

        line-height: 14px;
        text-align: center;
        font-size: 8px;
        z-index: 1500;

        &:hover {
            cursor: pointer;
        }

        &.full-page {
            margin-left: 10px !important;
        }

        &.collapsed {
            width: 50px;
            bottom: -16px;
            background: #e3e3e3;

            span {
                font-size: 10px;
                margin-right: 3px;
            }
        }
    }
}
.notification-bullet {
    &.is-read & {
      &-point {
        @apply bg-gray-400 dark:bg-gray-500;
      }
  
      &-bubble {
        @apply bg-gray-200 dark:bg-gray-800;
  
        svg {
          @apply text-gray-500 dark:text-gray-400;
        }
      }
    }
  
    &.is-unread & {
      &-point {
        @apply bg-primary-500;
      }
  
      &-bubble {
        @apply bg-primary-100;
  
        svg {
          @apply text-primary-500;
        }
      }
    }
  }
</style>
